import React, { useState, useEffect, useRef } from 'react';

const TeamCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [memberInfo, setMemberInfo] = useState({ opacity: 1 });
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const teamMembers = [
    { 
      name: "Rafael Lima", 
      role: "Diretor de Montagem de Eventos",
      image: "/equipe1.svg"
    },
    { 
      name: "Pedro Ommã", 
      role: "Diretor de Fotografia",
      image: "/equipe4.svg"
    }
  ];

  const updateCarousel = (newIndex) => {
    if (isAnimating) return;
    setIsAnimating(true);

    const validIndex = ((newIndex % teamMembers.length) + teamMembers.length) % teamMembers.length;
    setCurrentIndex(validIndex);

    // Fade out member info
    setMemberInfo({ opacity: 0 });

    // Fade in new member info after delay
    setTimeout(() => {
      setMemberInfo({ opacity: 1 });
    }, 300);

    // Reset animation flag
    setTimeout(() => {
      setIsAnimating(false);
    }, 800);
  };

  const getCardClass = (index) => {
    const offset = ((index - currentIndex + teamMembers.length) % teamMembers.length);
    
    if (offset === 0) return 'center';
    if (offset === 1) return 'right-1';
    if (offset === 2) return 'right-2';
    if (offset === teamMembers.length - 1) return 'left-1';
    if (offset === teamMembers.length - 2) return 'left-2';
    return 'hidden';
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft') {
      updateCarousel(currentIndex - 1);
    } else if (e.key === 'ArrowRight') {
      updateCarousel(currentIndex + 1);
    }
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].screenX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].screenX;
    handleSwipe();
  };

  const handleSwipe = () => {
    const swipeThreshold = 50;
    const diff = touchStartX.current - touchEndX.current;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        updateCarousel(currentIndex + 1);
      } else {
        updateCarousel(currentIndex - 1);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [currentIndex]);

  return (
    <div className="team-carousel-wrapper">

      <div className="team-carousel-container">
        <button 
          className="team-nav-arrow left"
          onClick={() => updateCarousel(currentIndex - 1)}
        >
          ‹
        </button>
        
        <div className="team-carousel-track">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className={`team-card ${getCardClass(index)}`}
              onClick={() => updateCarousel(index)}
            >
              <img 
                src={member.image} 
                alt={member.name}
                onError={(e) => {
                  e.target.src = '/team-placeholder.svg';
                }}
              />
            </div>
          ))}
        </div>
        
        <button 
          className="team-nav-arrow right"
          onClick={() => updateCarousel(currentIndex + 1)}
        >
          ›
        </button>
      </div>

      <div className="team-member-info" style={memberInfo}>
        <h2 className="team-member-name">{teamMembers[currentIndex].name}</h2>
        <p className="team-member-role">{teamMembers[currentIndex].role}</p>
      </div>

      <div className="team-dots">
        {teamMembers.map((_, index) => (
          <div
            key={index}
            className={`team-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => updateCarousel(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default TeamCarousel;